import React, { ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { MaterialUiPickersDate } from 'transfix-ui/core/pickers'
import { DatePicker, IDatePickerProps } from 'transfix-ui'

type IBaseControllerProps = ControllerProps<ComponentType<IDatePickerProps>>

interface IControlledDatePickerProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  onChange?: (changedDate: MaterialUiPickersDate) => void
  DatePickerProps?: Omit<IDatePickerProps, 'onChange' | 'value'> & {
    dataTest?: string
  }
}

export const ControlledDatePicker: FC<IControlledDatePickerProps> = ({
  control,
  defaultValue,
  name,
  DatePickerProps = {},
  onChange: onDateChange,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = (date: moment.Moment | null) => {
          onChange(date)
          if (onDateChange) {
            onDateChange(date)
          }
        }

        const clearHandler = () => {
          onChange(null)
        }

        return (
          <DatePicker
            value={value}
            onChange={changeHandler}
            onClear={clearHandler}
            {...DatePickerProps}
          />
        )
      }}
    />
  )
}

export default ControlledDatePicker
